module.exports = __webpack_public_path__ + "img/product_img1.9bc325eb.png";